import { ConstrainMode, DetailsList, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataOperation_Echeancier_Stade } from '../../data/DataOperation_Echeancier_Stade';
import { Immocom } from '../../specifique/immocom';

export class DetailsListOperation_Echeancier_Stade extends Component {

    static defaultProps = {
        idOperation: undefined,
        idEcheancier: undefined,
    };

    constructor(props) {
        super(props);
        this._columns = this._getColumns();
        /* YD : 20221226 : inutile */
        //this._isSortedDescending = false;
        //this._sortedColumn = "pourcentageCumul";
        this._objetState = {
            items: [],
            /* --- */
            hideMessageBarFiltres: true,
            hideMessageBarWarning: true,
            hideMessageBarError: true
        };
        this.state = { ... this._objetState };
    };

    _creationContent = () => {
        return <DetailsList
            columns={this._columns}
            constrainMode={ConstrainMode.unconstrained}
            items={this.state.items}
            onRenderDetailsHeader={this._onRenderDetailsHeader}
            onRenderRow={this._onRenderRow}
            selectionMode={SelectionMode.none}
        />
    };

    _chargementDonnees = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement en cours..."
        });

        /* YD : 20221226 : inutile
         *this._sortedColumn, this._isSortedDescending)
         * */
        const { idOperation, idEcheancier } = this.props;
        const filtres = { idOperation, idEcheancier };
        DataOperation_Echeancier_Stade._chargementOperation_Echeancier_Stades(filtres, null, false)
            .then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const stades = responseFetch.reponseAPIobjet || [];
                const state = { items: stades };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else {
                const state = { items: [] };
                Immocom.onTraitementErreurAvecState(this, state, retourVerif, responseFetch);
            }
        });
    };

    _getColumns = () => {
        return [
            {
                key: "pourcentageCumul",
                minWidth: 70,
                maxWidth: 70,
                name: "Cumul",
                onRender: (item) => {
                    const style = {
                        backgroundColor: "#fd0400",
                        borderRadius: "5px",
                        color: "#fff",
                        fontWeight: "600",
                        padding: "10px",
                    };
                    const { pourcentageCumul } = item;
                    const title = `${parseFloat(pourcentageCumul * 100).toFixed(10)} %`;
                    return <span style={style} title={title}>{parseFloat(pourcentageCumul * 100).toFixed(2)}&nbsp;%</span>;
                }
            },
            {
                isResizable: true,
                key: "nomStade",
                name: "Stade",
                onRender: (item) => {
                    const style = { color: "#fd0400" };
                    return <span style={style}>{item.nomStade}</span>
                }
            },
            {
                key: "pourcentageAvancementTravaux",
                minWidth: 100,
                maxWidth: 100,
                name: "Avancement",
                onRender: (item) => {
                    const { pourcentageAvancementTravaux } = item;
                    const title = `${parseFloat(pourcentageAvancementTravaux * 100).toFixed(10)} %`;
                    return <span title={title}>{parseFloat(pourcentageAvancementTravaux * 100).toFixed(2)}&nbsp;%</span>;
                }
            },
            {
                key: "datePrevisionnelle",
                minWidth: 150,
                maxWidth: 150,
                name: "Date prévisionnelle",
                onRender: (item) => <span>{Scriba.date().stringDateFormatCourt(item.datePrevisionnelle)}</span>
            },
            {
                key: "dateReelle",
                minWidth: 150,
                maxWidth: 150,
                name: "Date réelle",
                onRender: (item) => <span>{Scriba.date().stringDateFormatCourt(item.dateReelle)}</span>
            }
        ];
    };

    componentDidMount = () => {
        this._chargementDonnees();
    };

    componentDidUpdate = (prevProps) => {
        const { idEcheancier } = this.props;
        if (!!idEcheancier && prevProps.idEcheancier !== idEcheancier)
            this._chargementDonnees();
    };

    render = () => {

        return <DetailsList
            columns={this._columns}
            constrainMode={ConstrainMode.unconstrained}
            items={this.state.items}
            selectionMode={SelectionMode.none}
        />;

    };

};